module.exports = __webpack_public_path__ + "static/media/emp.d4275c6c.png";